module.exports = __webpack_public_path__ + "static/media/ata-seti.fa255131.jpg";